import Thumbnail1 from '../assets/thumbnail1.jpeg';
import Thumbnail2 from '../assets/thumbnail2.jpeg';
import Thumbnail3 from '../assets/thumbnail3.jpeg';
import Thumbnail4 from '../assets/thumbnail4.jpeg';

export const comments = [
  {
    id: 0,
    author: 'Sarah Coletti',
    moment: '1 day ago',
    comment: 'It\'s confirmed - Kris is DEFINITELY everyone\'s favorite human ever and we all wish we had her as a friend IRL! As always, thank you so much just for being you Kris! 🥰👑💖',
    likeCount: '2.7k',
    thumbnail: Thumbnail1
  },
  {
    id: 1,
    author: 'Makena Johnston',
    moment: '2 weeks ago',
    comment: `Kris: faints at sight of needle
    Also Kris: Has nose and both ears pierced.
    Also Also Kris: gives mom lecture over eyelid piercing. 😂😂❤❤`,
    likeCount: '49',
    thumbnail: Thumbnail2
  },
  {
    id: 2,
    author: 'Yellow&Pink Martinez',
    moment: '12 days ago',
    comment: `I didn't look away ...
    I just closed my eyes. I love you Kris you brighten up all of our days, and I appreciate all the compliments you give us. And I'll give one to you - You are so bright and full of positive energy We All love you💛`,
    likeCount: '2.7k',
    thumbnail: Thumbnail3
  },
  {
    id: 3,
    author: 'Caria Elliott',
    moment: '4 months ago',
    comment: 'I love the way Kris could be having the worst day, not feeling well but she still puts a smile on her face just to make us feel better.  Thanks Kris!'
    ,
    likeCount: '523',
    thumbnail: Thumbnail4
  },
  {
    id: 4,
    author: 'Sarah Coletti',
    moment: '1 day ago',
    comment: 'It\'s confirmed - Kris is DEFINITELY everyone\'s favorite human ever and we all wish we had her as a friend IRL! As always, thank you so much just for being you Kris! 🥰👑💖',
    likeCount: '2.7k',
    thumbnail: Thumbnail1
  },
  {
    id: 5,
    author: 'Makena Johnston',
    moment: '2 weeks ago',
    comment: `Kris: faints at sight of needle
    Also Kris: Has nose and both ears pierced.
    Also Also Kris: gives mom lecture over eyelid piercing. 😂😂❤❤`,
    likeCount: '49',
    thumbnail: Thumbnail2
  },
  {
    id: 6,
    author: 'Yellow&Pink Martinez',
    moment: '12 days ago',
    comment: `I didn't look away ...
    I just closed my eyes. I love you Kris you brighten up all of our days, and I appreciate all the compliments you give us. And I'll give one to you - You are so bright and full of positive energy We All love you💛`,
    likeCount: '2.7k',
    thumbnail: Thumbnail3
  },
  {
    id: 7,
    author: 'Caria Elliott',
    moment: '4 months ago',
    comment: 'I love the way Kris could be having the worst day, not feeling well but she still puts a smile on her face just to make us feel better.  Thanks Kris!'
    ,
    likeCount: '523',
    thumbnail: Thumbnail4
  },
];